import styled from 'styled-components';
import { colors } from '@/styles';

export const SchemaField = styled.div<{
  $status?: string;
  $isDiff?: boolean;
  $visible: boolean;
  $isAdded: boolean;
  $editable: boolean;
}>`
  font-family: var(--font-family-mono);
  gap: 10px;
  width: 100%;
  display: grid;
  grid-template-columns: ${(props) => (props.$editable ? '20px 1fr 36px' : '20px 1fr')};

  color: ${(props) => colors.semantic.diff[props.$status as keyof typeof colors.semantic.diff]?.indicator};
  background-color: ${(props) => colors.semantic.diff[props.$status as keyof typeof colors.semantic.diff]?.background};

  color: ${(props) =>
    props.$isAdded ? colors.semantic.positive.primary : props.$visible ? 'inherit' : colors.secondary.lightGray3};
`;

export const EditActions = styled.div`
  display: flex;
  gap: 5px;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const SchemaFieldDetails = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px;

  &.current {
    color: ${colors.semantic.positive.dark};
  }

  &.deleted {
    color: ${colors.semantic.negative.primary} !important;
    text-decoration: line-through;
  }

  &.previous,
  &.previous span {
    color: ${colors.semantic.negative.primary} !important;
    text-decoration: line-through;
  }

  .field-name {
    max-width: 100%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    span {
      padding: 0 5px;
    }
  }
`;

export const DataTypeIndicator = styled.div`
  flex: 0%;
  min-width: 20px;
  color: ${colors.semantic.placeholder};
`;

export const ColumnVisibility = styled.div`
  padding-top: 1px;
  display: flex;
  align-items: center;

  cursor: pointer;
  &:hover {
    color: ${colors.primary.black};
  }
`;
